<template>
  <div>
    <div class="mt-order-top" style="height: auto;">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单搜索：">
          <el-input v-model="searchForm.name" placeholder="请输入订单号/用户昵称/手机号搜索" class="mt-search-width"></el-input>
        </el-form-item>
        <el-form-item label="一级经销商：">
          <el-select v-model="searchForm.firstLevelDealerId" placeholder="请选择" class="mt-search-width">
            <el-option
              v-for="item in firstLevelDealerIdArr"
              :key="item.id"
              :label="item.dealerName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间筛选：">
          <el-date-picker
            v-model="searchForm.date"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- <el-button @click="exportExcelBtn" v-loading.fullscreen.lock="fullscreenLoading">数据导出</el-button> -->
    </div>
    <div>
      <el-table
        :data="infoList"
        style="width: 100%">
        <el-table-column
          align="center"
          prop="orderNo"
          label="订单号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="firstLevelDealerName"
          label="一级经销商">
        </el-table-column>
        <el-table-column
          align="center"
          prop="secondLevelDealerName"
          label="二级经销商">
        </el-table-column>
        <el-table-column
          align="center"
          prop="mobile"
          label="二级经销商电话">
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderMoney"
          label="订单金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="goodsNumber"
          label="订单数量">
        </el-table-column>
        <el-table-column
          align="center"
          prop="createTime"
          label="申请时间">
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderStatus"
          label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus === 0">待发货</span>
            <span v-if="scope.row.orderStatus === 1">
              已发货
            </span>
            <span v-if="scope.row.orderStatus === 2">已收货</span>
            <span v-if="scope.row.orderStatus === 3">已取消</span>
          </template>
        </el-table-column>
        <el-table-column
          fixed="right"
          align="center"
          width="240"
          label="操作">
          <template slot-scope="scope">
            <el-button @click="orderGoodsBtn(scope.row.id)" type="text" size="small">订单商品</el-button>
            <el-button v-if="scope.row.orderStatus == 0" @click="sendOpenBtn(scope.row.id)" type="text" size="small">发货</el-button>
        </template>
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
      </div>
    </div>
  </div>
</template>

<script>
import { queryDealerOrderPageList, orderExportExcel, sendThirdOrder, queryFirstDealerAccountList } from '@/api/distributor'
export default {
  name: 'AgentOrderSingle',
  props: {
    tabCurrent: {
      type: Number,
      default: 99
    }
  },
  watch: {
    "tabCurrent"(newVal, oldVal) {
      this.currentPage = 1;
      this.getInfoList();
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      searchForm: {
        name:'',
        firstLevelDealerId:'',
        date:['', '']
      },
      firstLevelDealerIdArr:[],
      activeName:'first',
      limitLength: this.$limitLength,
      pageTotal: 0,
      infoList:[],
      currentPage: 1,
      infoId:''
    }
  },
  mounted () {
    var that = this;
    that.firstLevelDealerFun();
    that.getInfoList();
  },
  methods: {
    // 订单商品
    orderGoodsBtn(infoId){
      this.$router.push({path: '/agent_goods_list', query: {dataId: infoId}})
    },
    // 获取一级经销商账号列表
    firstLevelDealerFun(){
      var that = this;
      queryFirstDealerAccountList({}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.firstLevelDealerIdArr = data
        }
        if (res.errorCode === '4002') {
          that.searchForm.firstLevelDealerId = '';
          that.firstLevelDealerIdArr = []
        }
      })
    },
    // 导出操作
    exportExcelBtn(){
      let that = this
      let deliveryType = that.searchForm.deliveryType
      let searchName = that.searchForm.name
      let tabCurrent = that.tabCurrent
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      that.fullscreenLoading = true;
      orderExportExcel({webSearchQuery: searchName, deliveryType: deliveryType, startCreateDate: startDate, endCreateDate: endDate, orderStatus:tabCurrent}).then((res) => {
        that.fullscreenLoading = false;
          // 处理二进制数据并创建 Blob 对象
          const blobObj = new Blob([res], { type: 'application/octet-stream' });
          // 创建一个链接并设置下载属性
          const downloadLink = document.createElement("a");
          let url = window.URL || window.webkitURL || window.moxURL; // 兼容不同浏览器的 URL 对象
          url = url.createObjectURL(blobObj);
          downloadLink.href = url;
          downloadLink.download = '代理订单列表'+new Date().getTime()+'.xlsx'; // 设置下载的文件名
          // 将链接添加到 DOM 中，模拟点击
          document.body.appendChild(downloadLink);
          downloadLink.click();
          // 移除创建的链接和释放 URL 对象
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
      })
    },
    // 发货弹窗-打开操作
    sendOpenBtn(infoId){
      this.infoId = infoId;
      var that = this;
      that.$confirm('是否确认发货？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        sendThirdOrder({ id: infoId}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            that.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let firstLevelDealerId = that.searchForm.firstLevelDealerId
      let searchName = that.searchForm.name
      let tabCurrent = that.tabCurrent
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      queryDealerOrderPageList({ webSearchStr: searchName, firstLevelDealerId: firstLevelDealerId, startCreateDate: startDate, endCreateDate: endDate, pageNum: page, pageSize: that.limitLength, orderStatus:tabCurrent}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/distributor/components/AgentOrderSingle.vue